<rt-avatar
  class="avatar"
  [type]="avatarType()"
  [size]="avatarSize()"
  [fullName]="data().name"
  [initials]="data().initials ?? undefined"
  [imageSrc]="data().avatarUrl ?? null"
  context="candidate"
/>
<div class="text">
  <div class="title-row">
    <span class="title">{{ data().name }}</span>
    <ng-content select="[slot=title-badge]" />
  </div>
  @if (data().subtitle; as subtitle) {
    @switch (subtitle.kind) {
      @case ('text') {
        <span class="meta">{{ subtitle.text }}</span>
      }
      @case ('job-ref') {
        <span class="meta meta--job">
          <span [class]="['status-dot', 'status-dot--' + subtitle.status]"></span>
          <span>{{ subtitle.title }}</span>
        </span>
      }
      @case ('jobs-count') {
        <span class="meta">{{
          'tlc.tellent_assistant.list_item.in_jobs_count' | translate: { count: subtitle.count }
        }}</span>
      }
    }
  }
</div>
